import { Component, Inject } from "@angular/core";
import { CommonModule, formatDate } from "@angular/common";
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogRef } from "@angular/material/dialog";
import { ButtonModule } from "primeng/button";
import { TagModule } from "primeng/tag";
import { TableModule } from "primeng/table";
import { CBoxPublicAdminGetCommandStatusListResponse } from "@server/services/cbox/public/api/v1/resources/internal/boxes/list/types";
import { LockerAdminActionLogState, LockerAdminOpenDoorActionLogState } from "../cbox-admin-locker-info.component";

@Component({
  selector: "app-cbox-admin-locker-command-details",
  templateUrl: "./cbox-admin-locker-command-details.component.html",
  styleUrls: ["./cbox-admin-locker-command-details.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogClose,
    MatDialogContent,
    ButtonModule,
    TagModule,
    TableModule
  ]
})
export class CBoxAdminLockerCommandDetailsComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public command: CBoxPublicAdminGetCommandStatusListResponse[number]
  ) {}

  formatDate(date: Date | undefined): string {
    if (!date) {
      return "";
    }
    return formatDate(date, "dd-MM-YYYY HH:mm:ss.SSS", "ro-RO", "Europe/Bucharest");
  }
  getCommandStateSeverity(state: LockerAdminActionLogState) {
    switch (state) {
      case LockerAdminActionLogState.FINISHED_SUCCESS:
        return "success";
      case LockerAdminActionLogState.FINISHED_ERROR:
        return "danger";
      case LockerAdminActionLogState.IN_PROGRESS:
      case LockerAdminActionLogState.INITIAL:
        return "warning";
      default:
        return "info";
    }
  }

  getDoorActionStateSeverity(state: LockerAdminOpenDoorActionLogState) {
    switch (state) {
      case LockerAdminOpenDoorActionLogState.FINISHED_SUCCESS:
        return "success";
      case LockerAdminOpenDoorActionLogState.FINISHED_ERROR:
      case LockerAdminOpenDoorActionLogState.FINISHED_TIMEOUT:
        return "danger";
      case LockerAdminOpenDoorActionLogState.IN_PROGRESS:
      case LockerAdminOpenDoorActionLogState.INITIAL:
        return "warning";
      default:
        return "info";
    }
  }
}